<template>
  <div>
    <el-form class="demo-ruleForm">
      <el-form-item>
        <div class="cc-select-panel">
          <div class="cc-select-panel-left">
            <div class="cc-select-panel-module">
              <el-form-item class="query-form-item">
                <el-input
                  v-model="pager.crowdNameId"
                  clearable
                  :placeholder="selectPlaceholder"
                  @input="handleChange"
                >
                </el-input>
                <el-select v-model="pager.crowdSource" placeholder="请选择" @change="crowdSourceChange">
                  <el-option
                    v-for="item in crowListoptions"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-row class="border-line">
                <el-table
                  ref="table"
                  :data="table.data"
                  height="360"
                >
                  <el-table-column
                    prop="crowdName"
                    :show-overflow-tooltip="true"
                    label="人群包"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="updatedTime"
                    label="日期"
                  >
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <el-radio-group v-model="scope.row.matchType" @change="matchTypeChange($event, scope.row)">
                        <el-radio :label="0">定向</el-radio>
                        <el-radio :label="2">排除</el-radio>
                      </el-radio-group>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination
                  :currentpage="pager.pageNo"
                  :pagesize="pager.pageSize"
                  :totalcount="totalCount"
                  @handle-size-change="handleSizeChange"
                  @handle-current-change="handleCurrentChange"
                ></pagination>
              </el-row>
            </div>
          </div>
          <div class="cc-select-panel-right border-line" style="margin-top: 47px">
            <div class="cc-select-panel-module">
              <div class="cc-select-panel-module-header">
                <span class="cc-select-panel-module-header-title">已选</span>
                <span class="cc-select-panel-module-header-clear" @click="cleanSelectItem">清空</span>
              </div>
              <div class="cc-select-panel-module-container">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane :label="`${item.label}(${item.selected.length})`" v-for="(item, i) in selectedList" :key="item.key" :name="item.key">
                    <el-tag
                      class="region-input-item"
                      v-for="(it,index) in item.selected"
                      :key="'r'+index"
                      closable
                      @close="selectRemove(it, i)"
                    >{{it.crowdName}}</el-tag>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { debounce } from 'lodash'
export default {
  components: {},
  props: {
    echoData: { type: Array, default: () => [] },
    selectPlaceholder: { type: String, default: '请输入人群包名称或ID' },
  },
  data() {
    return {
      crowdSource: 0,
      crowListoptions: [
        { key: 0, label: '标签广场' },
        { key: 1, label: '数据银行' },
        { key: 2, label: '本地文件上传' },
        { key: 3, label: 'DSP' },
      ],
      selectedList: [
        { label: '定向', key: '0', selected: [] },
        { label: '排除', key: '2', selected: [] }
      ],
      activeName: '0',
      radio: '1',
      totalCount: 0,
      pager: {
        // order:"desc",
        // sort: 'crowdTagId',
        crowdNameId: '',
        crowdSource: 0,
        pageNo: 1,
        pageSize: 10,
        tvbOperator: 'like'
      },
      loading: false,
      table: {
        data: []
      },
    }
  },
  watch: {
    echoData: {
      handler: function (n, o) {
        if (n && n.length) {
          this.selectedList[0].selected = []
          this.selectedList[1].selected = []
          n.forEach(item => {
            if (item.matchType) {
              this.selectedList[1].selected.push(item)
            } else {
              this.selectedList[0].selected.push(item)
            }
          })
        }
      },
      immediate: true,
      deep: true
    },
    selectedList: {
      handler: function (n, o) {
        this.emitHandle()
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    emitHandle() {
      let arrs = []
      this.selectedList.forEach((item, index) => {
        arrs = arrs.concat(item.selected)
      })
      this.$emit('selected', arrs)
    },
    matchTypeChange(e, row) {
      e = e ? 1 : 0
      this.selectedList[e].selected.push(row)
      let otherIndex = e ? 0 : 1
      this.selectedList[otherIndex].selected = this.selectedList[otherIndex].selected.filter(item => item.crowdTagId !== row.crowdTagId)
    },
    crowdSourceChange(e) {
      this.pager.pageNo = 1
      this.handleSearch()
    },
    handleClick(tab, event) {},
    init() {
      this.handleSearch()
    },
    handleSearch() {
      this.pager.pageSize = 10
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      const filter = { ...this.pager }
      this.$service
        .getDmpCrowds(filter)
        .then((data) => {
          this.loading = false
          this.table.data = (data.list || []).map(item => {
            let matchTypes0 = this.selectedList[0].selected.map(it => it.crowdTagId)
            let matchTypes1 = this.selectedList[1].selected.map(it => it.crowdTagId)
            if (matchTypes0.includes(item.crowdTagId)) {
              return {
                ...item,
                matchType: 0
              }
            } else if (matchTypes1.includes(item.crowdTagId)) {
              return {
                ...item,
                matchType: 2
              }
            }
            return {
              ...item,
              matchType: ''
            }
          })
          this.totalCount = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.pageNo = val
      this.fetchData()
    },
    // 删除按钮
    selectRemove(it, index) {
      this.table.data.forEach(item => {
        if (item.crowdTagId === it.crowdTagId) {
          item.matchType = ''
        }
      })
      this.selectedList[index].selected = this.selectedList[index].selected.filter(item => item.crowdTagId !== it.crowdTagId)
    },
    // 清空所有选中的值
    cleanSelectItem() {
      this.selectedList.forEach(item => {
        item.selected = []
      })
      this.table.data.forEach(item => {
        item.matchType = ''
      })
    },
    handleChange: debounce(function (e) {
      this.pager.pageNo = 1
      this.handleSearch()
    }, 500)
  },
  created() {
    this.init()
  }
}
</script>
<style lang="stylus" scoped>
  >>>.el-pager {
    display none
  }
  >>>.el-tabs__content {
    line-height: 0!important;
  }
  >>>.el-tabs__header {
    margin 0 0 7px!important
  }
  .region-input-item {
    display inline-block!important;
    padding-right 20px;
    position relative
    min-width 250px!important
    max-width 300px!important
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    margin 3px 5px!important;
    >>> .el-icon-close  {
      position absolute
      top 5px;
      right 2px
    }
  }
  .border-line {
    border 1px solid #DCDFE6
  }
  >>>.el-form-item__content {
    margin-bottom: 10px;
  }
  >>> .el-tabs__item {
    width 50%
    text-align center
  }
  >>> .el-tabs__nav {
    width 100%
  }
  .cc-select-panel-module {
    >>> .el-form-item__content {
      line-height: 30px;
    }
    >>> .el-table th, >>> .el-table tr {
      height 40px!important
    }
    >>> .el-table--medium .el-table__cell {
      padding 0 0
    }

  }
  .cc-select-panel
    display flex
    min-height 160px
  .cc-select-panel-left
    flex 1
    margin-right 16px
    width 300px !important
  .cc-select-panel-left-module
    width 100%
    min-width 180px
  .cc-select-panel .cc-select-panel-left
    position relative
    display inline-flex
    vertical-align top
  .cc-select-panel .cc-select-panel-left-module
    display inline-block
    -webkit-box-flex 0
    -ms-flex none
    flex none
  .cc-select-panel
    .cc-select-panel-left-module:first-child:not(:last-child), .cc-select-panel-module
      border-top-right-radius 0
      border-bottom-right-radius 0
    .cc-select-panel .cc-select-panel-left-module:not(:first-child)
      margin-left -1px
    .cc-select-panel-module
      width 100%
      background-color #fff
      border-radius 3px
      overflow hidden
    .cc-select-panel-module-header
      border-bottom 1px solid #DCDFE6
      color #606266
      font-size 14px
      line-height 20px
      padding 8px 10px
      display flex
      justify-content space-between
    .cc-select-panel-module-container
      height 378px
      overflow-y auto
      position relative
    .cc-select-panel-right
      flex 0 0 250px
    .cc-select-panel-item
      padding 0px 12px
      cursor pointer
      display flex
      flex-direction row
      align-items center
    .cc-select-panel-item:hover
      background #f2f2f2
    .cc-select-panel-item-checkbox
      margin-right 6px
    .cc-select-panel-item-name
      display block
      cursor pointer
      white-space nowrap
      text-overflow ellipsis
      overflow hidden
      line-height 22px
      font-size 14px
      color #606266
      font-weight 400
    /* * 选中样式 * */
    .cc-select-panel-item-active .cc-select-panel-item-name
      color #f78400
    .cc-select-panel-item-active
      .cc-select-panel-item-toright, .el-icon-arrow-right
        color #f78400
    .cc-select-panel-item-toright
      position absolute
      right 12px
      cursor pointer
    .cc-select-panel-item-remove:first-child
      margin-top 6px
    .cc-select-panel-item-remove
      margin 8px 12px
      padding 2px 8px
      background-color #f2f2f2
      border-radius 4px
      position relative
    .cc-select-panel-item-remove .cc-select-panel-item-close
      position absolute
      right 8px
      top 3px
      line-height 18px
      cursor pointer
    .cc-select-panel-module-header .cc-select-panel-module-header-clear
      flex-shrink 0
      color #ff8b00
      cursor pointer
      margin-left 12px
    .cc-select-panel-module-header-clear-disabled
      flex-shrink 0
      color #999
      cursor not-allowed
      margin-left 12px
    .cc-select-panel-disabled .cc-select-panel-item-check
      pointer-events none
    .cc-select-panel-disabled .cc-select-panel-item-name
      color #999
      cursor not-allowed
    .cc-select-panel-disabled .k-checkbox.k-checked .k-wrapper, .cc-select-panel-disabled .k-checkbox.k-indeterminate .k-wrapper
      border-color #999
      background #999
    .cc-select-panel-disabled
      .cc-select-panel-item-remove, .cc-select-panel-item-close
        display none
    >>>.el-tag
      width 95%
      display flex
      flex-direction row
      justify-content space-between
      align-items center
      margin 5px
  .query-form-item >>> .el-form-item__content
    display flex
    flex-flow row nowrap
    .query-select
      width 100%
      margin-bottom: 10px;
  .mg-left
    margin-left 20px
</style>
